import generateString from 'shared_js/helpers/stringHelper/generateString';

function paymentTrackerFactory(
  tracker,
  trackerSchema = {
    pageSchema: 'payment_channels_page_view',
    eventSchema: 'payment_channels_event',
  },
) {
  function generateJourneyID() {
    const journeyId = generateString(32);
    sessionStorage.setItem('journey_id', journeyId);
    return journeyId;
  }
  function track(evn, additionalData = {}) {
    const enteringScreenTime = new Date();
    const userId = window.blGlobal ? window.blGlobal.user.id : window.USER.id;
    let userIdTrack = userId.toString();

    if (trackerSchema.eventSchema === 'lakupandai_inquiry_activity_event') {
      userIdTrack = userId.toString(36);
    }

    const journeyPayload = {};
    if (trackerSchema.eventSchema === 'lakupandai_event') {
      journeyPayload.journey_id =
        sessionStorage.getItem('journey_id') || generateJourneyID();
      additionalData.transaction_id = additionalData.transaction_id || '';
    }

    const data = {
      evn,
      ui: userIdTrack,
      t: enteringScreenTime.getTime(),
      ...additionalData,
      ...journeyPayload,
    };
    if (typeof tracker.event === 'function') {
      tracker.event(data);
    }
  }
  function trackPage(rObj) {
    track(trackerSchema.pageSchema, rObj);
  }
  function trackEvent(payload) {
    track(trackerSchema.eventSchema, {
      url: window.location.href,
      ...payload,
    });
  }
  function trackEventWithoutUrl(payload) {
    track(trackerSchema.eventSchema, {
      ...payload,
    });
  }
  return {
    track,
    trackPage,
    trackEvent,
    trackEventWithoutUrl,
  };
}
export default paymentTrackerFactory;
